/** @format */

import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import BarIcon from "../SvgIcons/BarIcon";
import CloseIcon from "../SvgIcons/CloseIcon";
import Logo from "../SvgIcons/Logo";
import "./style.scss";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleClick = () => {
    setMenuOpen(false); // Close the menu on link click
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const headerElement = document.querySelector("header");

    const handleScroll = () => {
      if (window.scrollY > 50) {
        headerElement.classList.add("smooth");
      } else {
        headerElement.classList.remove("smooth");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header>
      <div className='container'>
        <div className='header'>
          <Link to='/' className='header__logo' onClick={handleClick}>
            <Logo />
          </Link>
          <nav className='header__nav'>
            <div className='menu-icon' onClick={toggleMenu}>
              {menuOpen ? <CloseIcon /> : <BarIcon />}
            </div>

            <ul className={`header__menu ${menuOpen ? "active" : ""}`}>
              <li className='header__menu-item'>
                <NavLink
                  to='/about'
                  onClick={handleClick}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  About
                </NavLink>
              </li>
              <li className='header__menu-item'>
                <NavLink
                  to='/mission'
                  onClick={handleClick}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  Mission
                </NavLink>
              </li>
              <li className='header__menu-item'>
                <NavLink
                  to='/faqs'
                  onClick={handleClick}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  FAQ’s
                </NavLink>
              </li>
              <li className='header__menu-item'>
                <NavLink
                  to='https://docs.google.com/forms/d/e/1FAIpQLSfWYDeIHWj07TtQOTqGUo5I_p0yB2H8RMBpW4NQge-qZze7Tg/viewform?usp=sf_link'
                  target='_blank'
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  Feedback
                </NavLink>
              </li>
            </ul>
            {/* <button className="btn">Log In</button> */}
          </nav>
        </div>
      </div>
    </header>
  );
}
